export const messages = {
  en: {
    smallWeChat: {
      title: 'Payment Configuration',
      add: 'Add',
      name: 'Name',
      payPassword: 'Payment Password',
      merchantId: 'Merchant ID',
      merchantName: 'Merchant Name',
      description: 'Description',
      operation: 'Operation',
      edit: 'Edit',
      upload: 'Upload Attachment',
      requiredName: 'Name is required',
      requiredPayPassword: 'Payment password is required',
      requiredMerchantId: 'Merchant ID is required',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      fileTooLarge: 'File size cannot exceed 20MB'
    }
  },
  zh: {
    smallWeChat: {
      title: '支付配置',
      add: '添加',
      name: '名称',
      payPassword: '支付密码',
      merchantId: '商户ID',
      merchantName: '商户名称',
      description: '描述',
      operation: '操作',
      edit: '修改',
      upload: '上传附件',
      requiredName: '名称不能为空',
      requiredPayPassword: '支付密码不能为空',
      requiredMerchantId: '商户ID不能为空',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      fileTooLarge: '文件大小不能超过20MB'
    }
  }
}